export const LOAD_RESOURCE= "LOAD_RESOURCE";
export const RESET_RESOURCE= "RESET_RESOURCE";